import React from "react";
import NavbarHeader from "./NavbarHeader"
import SubMenu from "./NavbarSubmenu"
import HeaderSearch from "../HeaderSearch";
import { Link } from "../../../utils/types/Link";

import logo from "../../../assets/cibenka/logo.png";

export default function Navbar(){
    const featureMenu: Link[] = [
        {
            url: "#",
            linkName: "Právne služby"
        },
        {
            url: "/podla-odvetvia/pravo-nehnutelnosti",
            linkName: "Právo nehnuteľností"
        },
        {
            url: "/podla-odvetvia/obchodne-pravo",
            linkName: "Obchodné právo"
        },
        {
            url: "/podla-odvetvia/danove-pravo",
            linkName: "Daňové právo"
        },
        {
            url: "/podla-odvetvia/rodinne-pravo",
            linkName: "Rodinné právo"
        },
    ];

    return (
        <nav className="navigation navbar navbar-default">
            <div className="container">
                <NavbarHeader logo={logo}/>
                <div id="navbar" className="navbar-collapse collapse navbar-right navigation-holder">
                <button className="close-navbar"><i className="ti-close"></i></button>
                    <ul className="nav navbar-nav">
                        <SubMenu links={featureMenu}/>
                        <li><a href="/aktuality">Aktuality</a></li>
                        <li><a href="/kontakt">Kontakt</a></li>
                        <li><a href="/advokatska-kancelaria-puchov">O nás</a></li>
                    </ul>
                </div>
                <div className="cart-search-contact">
                    <HeaderSearch />
                </div>
            </div>
        </nav>
    )
}